/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
                  Filters for posts

created a generic function that will work with Barba or without Barba. 
You only need to pass the data-filter attribute 

ie.  

<button data-filter="all" >ALL</button>
<button  data-filter="{{itm.slug}}"> {{itm.name}}  </button>


~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

window.search_by_category = function (cat_slug) {
    const url = cat_slug
        ? `${window.location.pathname}?category=${cat_slug}`
        : window.location.pathname;
    window.location.href = url;
};

function setupFilterButtons() {
    const filterButtons = document.querySelectorAll(".filter-btn");
    // Remove old listeners to prevent duplicates on Barba transitions
    filterButtons.forEach((button) => {
        button.replaceWith(button.cloneNode(true));
    });

    // Re-query after cloning
    document.querySelectorAll(".filter-btn").forEach((button) => {
        button.addEventListener("click", function () {
            const category = this.getAttribute("data-filter");
            window.search_by_category(category === "all" ? "" : category);
        });
    });
}

export { setupFilterButtons };
